import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPreventRendererNotSupported } from '../types'
import { isPartytownNotSupported } from '../utils/partytownTester'
import { ExternalComponentUnsupportedBrowserError } from '@wix/external-component-renderer'

export const preventRendererNotSupportedFactory = withDependencies(
	[],
	(): IPreventRendererNotSupported => {
		return {
			preventRendererNotSupported: async () => {
				if (await isPartytownNotSupported()) {
					throw new ExternalComponentUnsupportedBrowserError('Incognito mode is not supported.')
				}
			},
		}
	}
)
